import { useMemo } from 'react'

import { AgChartOptions } from 'ag-charts-community'
import { AgCharts } from 'ag-charts-react'

import { ICReportChartPrimitive } from '@/pages/funds/ic-report/components/primitives/types'
import { diversifiers } from '@/react-query/queries/ic-report/hooks'

export interface RatesGammaChartProps extends ICReportChartPrimitive {}

export const RatesGammaChart: React.FC<RatesGammaChartProps> = ({ params, options }) => {
  const query = diversifiers.useRatesVolatilities(params)
  const data = query.data ?? []

  const formattedData = useMemo(() => {
    return data.map((item: any) => ({ ...item, date: new Date(item.date) }))
  }, [data])

  const mergedOptions: AgChartOptions = {
    title: {
      text: 'Net Gamma',
      fontSize: 14,
    },
    data: formattedData,
    series: [
      {
        type: 'line',
        xKey: 'date',
        yKey: 'SGIVR2UG Gamma',
        stroke: '#db3b1f',
        marker: {
          size: 0,
        },
      },
    ],
    axes: [
      {
        type: 'time',
        position: 'bottom',
        label: { format: '%d %b %y' },
        nice: false,
      },
      { type: 'number', position: 'left' },
    ],
    ...options,
  }

  return <AgCharts options={mergedOptions} />
}
